export enum PAYMENT_STATUS {
  PENDING = 'PENDING',
  FINAL = 'FINAL',
}

export interface IPaymentItem {
  label: string;
  price: string;
  status: PAYMENT_STATUS;
}

export interface IPaymentAvailability {
  loading: boolean;
  available: boolean;
}

export enum PAYMENT_INSTRUMENT_TYPE {
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  CARD = 'CARD',
  UNKNOWN = 'UNKNOWN',
}
